module.exports = __webpack_public_path__ + "static/media/lock.cb39e252.svg";